var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"white",attrs:{"fluid":"","fill-height":"","pa-0":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('div',{staticClass:"red"},[_c('div',{staticClass:"blue"},[_vm._v("\n        "+_vm._s(_vm.getMessage)+"\n      ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }